/**
 * Reads which template a Muze Studio chart was started from. It lives in utils, not in the muze-template service,
 * because the answer analytics properties (metrics-event.util) need it too, and utils may not import services.
 */

/** Parses the chart iframe's client state out of the visual props. Null when it is missing or not an object. */
export const parseClientState = (
    visualProps: unknown,
): Record<string, unknown> | null => {
    const clientState = (visualProps as Record<string, unknown> | null)
        ?.clientState;
    if (typeof clientState !== 'string') return null;
    try {
        const parsed = JSON.parse(clientState);
        return parsed && typeof parsed === 'object' && !Array.isArray(parsed)
            ? parsed
            : null;
    } catch {
        return null;
    }
};

/**
 * The template a chart was started from, or null when there is no lineage entry.
 * Callers check the chart type themselves.
 */
export const getSourceTemplate = (
    chartViz: { customVisualProps?: unknown } | null | undefined,
): { v: 1; id: string; name: string } | null => {
    const state = parseClientState(chartViz?.customVisualProps);
    const entry = state?.sourceTemplate as
        | { v?: unknown; id?: unknown; name?: unknown }
        | undefined;
    return entry?.v === 1 &&
        typeof entry.id === 'string' &&
        typeof entry.name === 'string'
        ? { v: 1, id: entry.id, name: entry.name }
        : null;
};
